import { List, Datagrid, TextField, Filter, TextInput } from "react-admin";
import { ListPagination } from "../../../utils";

const GroupsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nome" source="name" alwaysOn />
  </Filter>
);

const GroupsList = () => (
  <List
    hasCreate={true}
    perPage={25}
    exporter={false}
    title="Lista de Grupos"
    filters={<GroupsFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    bulkActionButtons={<div />}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
    </Datagrid>
  </List>
);

export default GroupsList;
